<template>
  <div class="sidebar-layout">
    <img src="@/assets/img/png/nav-logo.png" class="sidebar-layout__logo" />
    <div>
      <menu-item
        class="sidebar-layout__menu"
        v-for="item in menuItems"
        :key="item.id"
        :item="item"
        @on-menu-click="handleItemClick"
      ></menu-item>
    </div>
    <menu-item
      class="margin-auto"
      :item="helpItem"
      @on-menu-click="
        navigate('https://ayuda.lumineapp.com/ayuda_app_doctores/')
      "
    ></menu-item>
    <menu-item
      class=""
      :item="exitItem"
      @on-menu-click="openSignoutAlert"
    ></menu-item>

    <!-- <menu-item
      class=""
      item="refresh"
      @on-menu-click="refreshToken"
    ></menu-item> -->

    <span class="footer-text gray has-text-centered">{{ appVersion }}</span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import MenuItem from '@/components/navigation/desktop/MenuItem.vue'
import { NavigationMutations } from '@/store/navigation/mutations'
import { ItemMenu } from '@/store/navigation/types'
import { ENV } from '@/config'

var exitItem: ItemMenu = {
  id: 10,
  text: 'Salir',
  icon: 'exit-to-app',
  active: false,
  to: ''
} as ItemMenu

var helpItem: ItemMenu = {
  id: 10,
  text: 'Consulta manual',
  icon: 'help-circle',
  active: false,
  to: ''
} as ItemMenu

export default Vue.extend({
  name: 'SideBar',

  components: { MenuItem },

  data() {
    return {
      expandOnHover: false,
      expandWithDelay: false,
      mobile: 'reduce',
      reduce: false,
      exitItem: exitItem,
      helpItem: helpItem
    }
  },

  methods: {
    ...mapMutations(['SHOW_SIGNOUT_DIALOG']),
    ...mapMutations('navigation', [NavigationMutations.SET_ACTIVE_MENU]),
    ...mapActions('navigation', ['setAlertSidebar']),
    ...mapActions('signIn', ['googleRefrehToken']),

    handleItemClick(item: ItemMenu) {
      if (this.$route.path != (item.to as string)) {
        this.$router.push(item.to as string)
      }
      this.SET_ACTIVE_MENU(item)
    },

    openSignoutAlert() {
      this.SHOW_SIGNOUT_DIALOG(true)
    },

    navigate(url: string) {
      window.open(url, '_blank')
    },

    refreshToken() {
      this.googleRefrehToken()
    }
  },

  computed: {
    ...mapState('navigation', ['menuItems']),

    appVersion(): string {
      return 'version ' + ENV.appVersion
    }
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style
@import @/assets/sass/typography
.sidebar-layout
  display: flex
  flex-direction: column
  height: 100vh
  width: 290px
  z-index: 2
  background: $white
  padding: 16px
  box-shadow: -10px 0 8px -8px $strokes, 10px 0 8px -8px $strokes

  &__menu
    margin-bottom: 5px

  &__logo
    width: 80%
    height: 70px
    margin: 24px auto

.margin-auto
  margin-top: auto

.gray
  color: #E5E7E9
</style>
